import { render, staticRenderFns } from "./solarSpace.vue?vue&type=template&id=6fa0daa9"
import script from "./solarSpace.vue?vue&type=script&lang=js"
export * from "./solarSpace.vue?vue&type=script&lang=js"
import style0 from "./solarSpace.vue?vue&type=style&index=0&id=6fa0daa9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports